import * as BABYLON from "babylonjs";
import { CoordUtils } from "../core/coordUtils";
import { GeoPoint } from "../core/geoPoint";
import { GeoPolygon } from "../core/geoPolygon";
import { VectorUtils } from "../core/vectorUtils";
import { Country } from "../model/country";

export class CountryOutlineMesh extends BABYLON.Mesh {
    private _outlineMeshes: BABYLON.LinesMesh[];

    constructor(scene: BABYLON.Scene, country: Country) {
        super(`${country.isoCode}Outline`, scene);

        this._outlineMeshes = country.hdPolygons.polygons.map(it => this.createOutlineMeshFromPolygon(scene, it));
        this._outlineMeshes.forEach(it => it.parent = this);
    }

    private createOutlineMeshFromPolygon(scene: BABYLON.Scene, polygon: GeoPolygon): BABYLON.LinesMesh {
        let points = polygon.points.map(it => CoordUtils.geoToBabylon(it));
        let mesh = BABYLON.MeshBuilder.CreateLines(`${this.name}Part`, { points }, scene);
        mesh.registerBeforeRender(it => { it.getEngine().setDepthBuffer(false); });
        mesh.registerAfterRender(it => it.getEngine().setDepthBuffer(true));
        return mesh;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/display/countryOutlineMesh.ts